module.exports = __webpack_public_path__ + "b3637877bfc465bbbdf75c5cfc460fe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecipesLanding/pizza.png
// module id = 1385
// module chunks = 0